import React from 'react'
import "./components/CSS/style.css"
import Navbar from "./components/Navbar"
import MiddleSection from "./components/MiddleSection"

function App() {
  return (
    <>
      <Navbar />

      <MiddleSection />

    </>
  );
}

export default App;
